import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { formatEuro, formatPercent, formatCryptoQuantity, formatQuantity } from '../../utils/currency';
import { PositionAnalysis } from './analysis/stockAnalysis';

interface StockAnalyticsDialogProps {
  open: boolean;
  onClose: () => void;
  data: (PositionAnalysis & { symbol: string }) | null;
  portfolioTotals?: { totalInvested: number; totalValue: number };
  isCrypto?: boolean;
}

const StatBox: React.FC<{ label: string; value: string; color?: string }> = ({ label, value, color }) => (
  <Box sx={{ p: 2, borderRadius: 1, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider' }}>
    <Typography variant="caption" color="text.secondary">{label}</Typography>
    <Typography variant="subtitle1" fontWeight="bold" color={color || 'text.primary'}>{value}</Typography>
  </Box>
);

const StockAnalyticsDialog: React.FC<StockAnalyticsDialogProps> = ({ open, onClose, data, portfolioTotals, isCrypto }) => {
  if (!data) return null;
  const weight = portfolioTotals && portfolioTotals.totalValue > 0 ? (data.currentValue / portfolioTotals.totalValue) * 100 : 0;
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Análise da ação - {data.symbol}</DialogTitle>
      <DialogContent dividers>
        <Box sx={{
          display: 'grid',
          gap: 2,
          gridTemplateColumns: { xs: 'repeat(2, 1fr)', sm: 'repeat(3, 1fr)' }
        }}>
          <StatBox label="Unidades" value={isCrypto ? formatCryptoQuantity(data.totalShares) : formatQuantity(data.totalShares)} />
          <StatBox label="Preço médio" value={formatEuro(data.averagePrice)} />
          <StatBox label="Investido" value={formatEuro(data.totalInvested)} />
          <StatBox label="Valor atual" value={formatEuro(data.currentValue)} />
            <StatBox label="Lucro/Prejuízo" value={`${formatEuro(data.gainLoss)} (${formatPercent(data.gainLossPercentage)})`} color={data.gainLoss >= 0 ? 'success.main' : 'error.main'} />
          <StatBox label="Dividendos" value={formatEuro(data.dividends)} />
          <StatBox label="Peso na carteira" value={formatPercent(weight)} />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default StockAnalyticsDialog;
